<template>
    <div class="slider-control">
        <vue-slider v-model="val"
            tooltip="none"
            dotSize="24"
			:contained="true"
			:disabled="data.disabled || disabled"
            :data="data.data"
            :min="data.min"
            :max="data.max"
            :interval="data.interval"
            :dotStyle="dotStyle"
            :railStyle="railStyle"
            :processStyle="processStyle"
            :container="true"
			@click.native="handleSliderClick"
            @drag-end="dragEnd" />
    </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
    name: 'SliderControl',
    props:['data', 'id', 'disabled'], 
    components: {
        VueSlider
    },
    data: function(){
        return {
			isEmitting: false,
            dotStyle:{
				'background-color': '#EB0A1E',
				'box-shadow': 'none'  
            },
            railStyle: {
                'height': '3px'
            }, 
            processStyle: {
                'background-color': '#EB0A1E'
            }
        }
    },
    computed: {
        val: {
            get(){
                return this.data.val;
            },
            set(v){
                if (this.data.val != v){
                    this.$emit('update', v);
                }
            }
        }
    }, 
    methods: {
		emitDragEnd(){
			if (!this.data.disabled && !this.isEmitting){
				this.isEmitting = true;
				this.$emit('drag-end');
				setTimeout(()=>{
					this.isEmitting = false;
				}, 200);
			}
		},
		handleSliderClick(){
			this.emitDragEnd();
		},
        dragEnd(){
			this.emitDragEnd();
        }
	}
}
</script>

